import styled from 'styled-components'

export const WhiteBar = styled.div`
  height: 10rem;
  width: 100vw;
`

export const Wrapper = styled.div`
  max-width: 958px;
  margin: -4rem auto 0;
  border-radius: 1rem;

  @media only screen and (min-width: 1000px) {
    padding: 3rem;
  }
`
